import { defineAsyncComponent } from 'vue';

const components = [
  {
    name: 'GoBack',
    component: defineAsyncComponent(() => import('@/components/shared/buttons/GoBack.vue')),
  },
  {
    name: 'BevaModuleHeader',
    component: defineAsyncComponent(() => import('@/components/shared/BevaModuleHeader.vue')),
  },
];

export default {
  install: function (app: any) {
    components.forEach((component) => {
      app.component(component.name, component.component);
    });
  },
};
